import { api } from '../core/request';

/**
 * Send password reset email.
 * POST /forgot-password (Laravel default)
 */
export async function apiForgotPassword(email: string) {
  return api.post('/forgot-password', {
    method: 'POST',
    body: { email },
  });
}

/**
 * Complete password reset with token.
 * POST /reset-password (Laravel default)
 */
export async function apiResetPassword(data: {
  token: string;
  email: string;
  password: string;
  password_confirmation: string;
}) {
  return api.post('/reset-password', {
    method: 'POST',
    body: data,
  });
}
